import { UserType } from "../constants/settings";

export function isAllowAdmin(userData) {
  return userData && userData.loggedIn && userData.userType === UserType.agent && Array.isArray(userData.permissions) && userData.permissions.includes('TA_ADMIN');
}

export function isAllowPrintItinerary(userData) {
  return userData && userData.loggedIn && userData.userType === UserType.agent && Array.isArray(userData.permissions) && userData.permissions.includes('Print itinerary');
}